// Small helpers for Web Share API with graceful fallback.

export const canShareFiles = () => {
  try {
    const dummy = new File(["x"], "x.pdf", { type: "application/pdf" });
    return typeof navigator.canShare === "function" && navigator.canShare({ files: [dummy] });
  } catch {
    return false;
  }
};

export const canShareText = () =>
  typeof navigator !== "undefined" && typeof navigator.share === "function";

// Trigger a browser download of a Blob (used when Web Share isn't available).
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

// Copy a string to the clipboard with a permissions-fallback.
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
      return true;
    } catch {
      return false;
    }
  }
};

// Build a mailto: URL with the share link.
export const mailtoShareUrl = ({ subject, body }) => {
  const enc = encodeURIComponent;
  return `mailto:?subject=${enc(subject)}&body=${enc(body)}`;
};
